/**
 * Payment plan detail with info passed from the parent app
 */
Vue.component('pay-plan-details-cma', {
  template: `
  <div>
    <p><span class="label">Selected Plan</span> Three, Four, Five and Six Month Levelized</p>
    <div class="md-flex">
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Account Number</span> {{ accountId }}</p>
      </div>
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Current Balance</span> {{ frequencyDetails.totalAgreementAmount }}</p>
      </div>
    </div>
    <hr>
    <p class="text-500 text-md">Initial Payment Details</p>
    <div class="md-flex">
      <div class="w-md-50 m-r-md-20">
      <p><span class="label">Initial Payment Amount</span> {{ initialPaymentAmount }}</p>
      </div>
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Payment Due Before</span> {{ initialPaymentDueDate }}</p>
      </div>
    </div>
    <hr>
    <p class="text-500 text-md">Remaining Balance</p>
    <div class="md-flex">
      <div class="w-md-50 m-r-md-20">
      <p><span class="label">Payment Frequency</span> {{ frequencyDetails.termPeriodMonths }} monthly {{ paymentText }} of {{ frequencyDetails.paymentAmount }}</p>
      </div>
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Next Scheduled Payment Date</span> {{ nextPaymentDate }}</p>
      </div>
    </div>
  </div>
  `,

  /**
   * Props array
   */
  props: ['accountId', 'initialPaymentAmount', 'initialPaymentDueDate', 'nextPaymentDate', 'frequencyDetails'],

  computed: {
    paymentText() {
      return this.frequencyDetails.termPeriodMonths > 1 ? 'payments' : 'payment';
    },
  },

});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/vue/components/payPlanDetailsCma.js